import styled from 'styled-components';

export const StyleInput = styled.div`
#F1073NumberOfAttempts {
    @media only screen and (max-width: 1050px) {
        margin: ${props => props.margin ? props.margin : '0'};
    }
    @media only screen and (min-width: 1051px) {
        margin: 0;
    }
}
`;

export const LabelFontSize = styled.div`
#F347HmivalvePositionAfterTestLabel {
    @media only screen and (max-width: 1017px) {
        font-size: 8.4pt;
    }
    @media only screen and (min-width: 1018px) {
        font-size: ${props => props.formName === 'P7-16' && props.fontSize
                ? props.fontSize
                : '9pt'};
    }
}
`;
